export const PRIVACY_MODULE_STORE_NAME = 'PRIVACY_MODULE';

export const SHOW_PRIVACY_CONSENT_COMPONENT = 'SHOW_PRIVACY_CONSENT_COMPONENT';

export const INFORMATION_STORAGE_ACCESS_MUTATION_KEY = 'INFORMATION_STORAGE_ACCESS_MUTATION_KEY';
export const PERSONALIZATION_ITEM_MUTATION_KEY = 'PERSONALIZATION_ITEM_MUTATION_KEY';
export const AD_SELECTION_MUTATION_KEY = 'AD_SELECTION_MUTATION_KEY';
export const CONTENT_SELECTION_MUTATION_KEY = 'INFORMATION_SCONTENT_SELECTION_MUTATION_KEYTORAGE_ACCESS_MUTATION_KEY';
export const MEASUREMENT_MUTATION_KEY = 'MEASUREMENT_MUTATION_KEY';

export const INFORMATION_STORAGE_ACCESS_KEY = 'informationStorageAndAccess';
export const PERSONALIZATION_ITEM_KEY = 'personalisation';
export const AD_SELECTION_KEY = 'adSelection';
export const CONTENT_SELECTION_KEY = 'contentSelection';
export const MEASUREMENT_KEY = 'measurement';

export const INFORMATION_STORAGE_ACCESS_ITEM = {
    key: INFORMATION_STORAGE_ACCESS_KEY,
    title: 'PC_INFORMATION_STORAGE_ACCESS_TITLE',
    description: 'PC_INFORMATION_STORAGE_ACCESS_DESCRIPTION',
    consentTypes: [],
    mutationKey: INFORMATION_STORAGE_ACCESS_MUTATION_KEY,
};
export const PERSONALIZATION_ITEM = {
    key: PERSONALIZATION_ITEM_KEY,
    title: 'PC_PERSONALIZATION_TITLE',
    description: 'PC_PERSONALIZATION_DESCRIPTION',
    consentTypes: [],
    mutationKey: PERSONALIZATION_ITEM_MUTATION_KEY,
};
export const AD_SELECTION_ITEM = {
    key: AD_SELECTION_KEY,
    title: 'PC_AD_SELECTION_TITLE',
    description: 'PC_AD_SELECTION_DESCRIPTION',
    consentTypes: [],
    mutationKey: AD_SELECTION_MUTATION_KEY,
};
export const CONTENT_SELECTION_ITEM = {
    key: CONTENT_SELECTION_KEY,
    title: 'PC_CONTENT_SELECTION_TITLE',
    description: 'PC_CONTENT_SELECTION_DESCRIPTION',
    consentTypes: [],
    mutationKey: CONTENT_SELECTION_MUTATION_KEY,
};
export const MEASUREMENT_ITEM = {
    key: MEASUREMENT_KEY,
    title: 'PC_MEASUREMENT_TITLE',
    description: 'PC_MEASUREMENT_DESCRIPTION',
    consentTypes: ['ad_storage', 'ad_user_data', 'analytics_storage', 'ad_personalization'],
    mutationKey: MEASUREMENT_MUTATION_KEY,
};
